'use client';
import React, { ButtonHTMLAttributes, CSSProperties } from 'react';
import { twMerge } from 'tailwind-merge';

interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  src?: string;
  alt?: string;
  iconWidth?: number;
  iconHeight?: number;
  fill_background_color?: string;
  border_border_radius?: string;
  padding?: string;
  className?: string;
}

const IconButton = ({
  src = '/images/img-button.svg',
  alt = 'Icon',
  iconWidth = 36,
  iconHeight = 36,
  fill_background_color = 'bg-secondary-background',
  border_border_radius = 'rounded-xl',
  padding = 'p-[12px]',
  className,
  onClick,
  disabled = false,
  ...props
}: IconButtonProps) => {
  const customStyles: CSSProperties = {
    width: iconWidth,
    height: iconHeight,
  }

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (disabled) {
      event.preventDefault()
      return
    }
    
    if (typeof onClick === 'function') {
      onClick(event)
    }
  }

  return (
    <button data-component-id="src/components/ui/IconButton.tsx:46:4" data-component-path="src/components/ui/IconButton.tsx" data-component-line="46" data-component-file="IconButton.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22%5Bspread%5D%22%3A%22true%22%7D"
      onClick={handleClick}
      disabled={disabled}
      style={customStyles}
      className={twMerge(
        'inline-flex items-center justify-center transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed',
        fill_background_color,
        border_border_radius,
        padding,
        className
      )}
      aria-disabled={disabled}
      {...props}
    >
      <img data-component-id="src/components/ui/IconButton.tsx:60:6" data-component-path="src/components/ui/IconButton.tsx" data-component-line="60" data-component-file="IconButton.tsx" data-component-name="img" data-component-content="%7B%22elementName%22%3A%22img%22%2C%22src%22%3A%22%5Bvar%3Asrc%5D%22%2C%22alt%22%3A%22%5Bvar%3Aalt%5D%22%2C%22className%22%3A%22w-full%20h-full%20object-contain%22%7D" 
        src={src} 
        alt={alt}
        width={180}
        height={80}
        className="w-full h-full object-contain"
      />
    </button>
  )
}

export default IconButton